module.exports = __webpack_public_path__ + "../resources/images/weatherFlat_sprite-974423b39787e65145ada303093c052f.png";